import React from "react";
import {
  AdminUpdateOrganizationMutation,
  useAdminOrganizationQuery,
  useAdminUpdateOrganizationMutation,
} from "@apollo/ops";
import { MessageSeverity } from "@shared/types/Severity";
import { toast } from "@utilities/toast";
import {
  LogisticsPartnerForm,
  LogisticsPartnerFormData,
} from "./LogisticsPartnerForm";

type UpdateLogisticsPartnerProps = {
  logisticsPartnerId: number;
  onUpdate: (data: AdminUpdateOrganizationMutation) => void;
};

export function UpdateLogisticsPartner({
  logisticsPartnerId,
  onUpdate,
}: UpdateLogisticsPartnerProps) {
  const { data } = useAdminOrganizationQuery({
    variables: {
      id: logisticsPartnerId,
    },
  });

  const [updateOrganization] = useAdminUpdateOrganizationMutation();

  if (!data) {
    return null;
  }

  const handleSubmit = async ({ name }: LogisticsPartnerFormData) => {
    try {
      const { data } = await updateOrganization({
        variables: {
          id: logisticsPartnerId,
          name,
        },
      });

      if (data && onUpdate) {
        onUpdate(data);
      }

      toast.current?.show({
        severity: MessageSeverity.success,
        summary: "",
        detail: `Update LogisticsPartner ${name}`,
      });
    } catch (error) {
      // TODO handle other error case
      if (error.message) {
        toast.current?.show({
          severity: MessageSeverity.error,
          summary: "",
          detail: error.message,
        });
      }
    }
  };

  return (
    <LogisticsPartnerForm
      submitText="Update"
      onSubmit={handleSubmit}
      defaultValues={data.organization}
    />
  );
}
